

import React, {useEffect , useState }from "react";
import {
  FaLeaf,
  FaIndustry,
  FaClipboardList,
  FaUsers,
  FaCalendarAlt,
  FaDollarSign,
  FaChartLine,
  FaUserCheck,
  FaTree,
  FaObjectGroup,
  FaClock,
  FaMoneyBillWave,
  FaPercent
} from "react-icons/fa";


import { getDashboardStats } from "../../services/dashbboard/adminReportService";

// const dashboardStats = [
//   { label: "Total Users", value: 128, icon: <FaUsers />, color: "primary" },
//   { label: "Active Plans", value: 3, icon: <FaUserCheck />, color: "success" },
//   { label: "Total Plants", value: 34, icon: <FaTree />, color: "info" },
//   { label: "Total Plant Groups", value: 7, icon: <FaObjectGroup />, color: "dark" },
//   { label: "Upcoming Schedules", value: 12, icon: <FaClock />, color: "warning" },
//   { label: "Revenue", value: "$48,500", icon: <FaMoneyBillWave />, color: "danger" },
// ];

const dashboardItems = [
  { title: "Plant Group", icon: <FaLeaf />,        link: "/console/admin/plant-groups" },
  { title: "Plant", icon: <FaIndustry />,          link: "/console/admin/plants" },
  { title: "Plans", icon: <FaClipboardList />,     link: "/console/admin/plans" },
  { title: "Users", icon: <FaUsers />,             link: "/console/admin/users" },
  { title: "Scheduler", icon: <FaCalendarAlt />,   link: "/console/admin/scheduler" },
  { title: "Finance", icon: <FaDollarSign />,      link: "/console/admin/finance" },
  { title: "Discount", icon: <FaPercent />,      link: "/console/admin/discount" },
];

const AdminConsole = () => {

  const [stats, setStats] = useState([]);

  const [dashboardStats, setDashboardStats] = useState([]);


  useEffect(()=>{
      loadStats();
  },[]);

  const loadStats = async ()=>{

    try 
    {
      const responseStats = await getDashboardStats();

      // console.log(stats)

      setStats(responseStats)


      const dashboardStats = [
            { label: "Total Users", value: responseStats.TotalUsers, icon: <FaUsers />, color: "primary" },
            { label: "Active Plans", value: responseStats.ActivePlans, icon: <FaUserCheck />, color: "success" },
            { label: "Total Plants", value: responseStats.TotalPlants  , icon: <FaTree />, color: "info" },
            { label: "Total Plant Groups", value: responseStats.TotalPlantGroups , icon: <FaObjectGroup />, color: "dark" },
            { label: "Upcoming Schedules", value: responseStats.UpcomingSchedules  , icon: <FaClock />, color: "warning" },
            { label: "Revenue", value: responseStats.Revenue , icon: <FaMoneyBillWave />, color: "danger" },
          ];

      setDashboardStats(dashboardStats);
    } 
    catch(err){

    } 

     

  };


  return (
    <div className="container py-5">
      <h2 className="text-center fw-bold mb-5">Admin Console</h2>

      {/* Statistics */}
      <div className="row g-4 mb-5">
        {dashboardStats.map((stat, index) => (
          <div className="col-sm-6 col-md-4 col-lg-2" key={index}>
            <div className={`card text-white bg-${stat.color} shadow-sm h-100`}>
              <div className="card-body text-center">
                <div style={{ fontSize: "1.8rem" }} className="mb-2">
                  {stat.icon}
                </div>
                <h6 className="card-title">{stat.label}</h6>
                <p className="card-text fw-bold">{stat.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Cards */}
      <div className="row g-4">
        {dashboardItems.map((item, index) => (
          <div className="col-md-4" key={index}>
            <div className="card text-center shadow-sm h-100">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="mb-3" style={{ fontSize: "3rem", color: "#0d6efd" }}>
                  {item.icon}
                </div>
                <h5 className="card-title mb-3">{item.title}</h5>
                <a href={item.link} className="btn btn-outline-primary mt-auto">
                  Go to {item.title}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminConsole;
